import { MotionFrame } from "../utilities/framer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MobiInfoUnit = ({
    icon,
    topic,
    textDesc
}) => {
    return (
        <MotionFrame>
            <div className="mobi-info glassy-effect">
                <div className="ico pnk-bg">
                    <FontAwesomeIcon icon={icon} color="#fff" size={32} />
                </div>
                <div className="service-cap">{topic}</div>
                <div className="cnt-service-text">{textDesc}</div>
            </div>
        </MotionFrame>
    );
}


export const GraphicsInfoUnit = ({
    icon,
    topic,
    textDesc
}) => {
    return (
        <MotionFrame>
            <div className="mobi-info glassy-effect">
                <div className="ico pnk-bg">
                    <FontAwesomeIcon icon={icon} color="#fff" size={32} />
                </div>
                <div className="service-cap">{topic}</div>
                <div className="cnt-service-text">{textDesc}</div>
            </div>
        </MotionFrame>
    );
}

